import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_entitlement_auto_top_up_event_filter_job_role_RowClass,
} from '../../../dbschema';

export class ClaimEntitlementAutoTopUpEventJobRoleFilterContainerModel extends BaseContainerModel {
  bl_aat_entitlement_auto_top_up_event_filter_job_role: bl_aat_entitlement_auto_top_up_event_filter_job_role_RowClass =
    new bl_aat_entitlement_auto_top_up_event_filter_job_role_RowClass();
}
